export default __webpack_public_path__ + "static/media/led1_up.3b17060e.svg";